import { observer } from "mobx-react-lite";
import { ItemListAsyncNoteRowData } from "@/components/item-list/types";
import { FC } from "react";
import { useAppStore } from "@/store";
import { ItemListItemRow } from "./item-list-item-row";
import { APPEARANCES_WITHOUT_SEPARATOR_SET } from "@/components/item-list/constants";

export interface ItemListAsyncNoteRowProps {
  data: ItemListAsyncNoteRowData;
}

export const ItemListAsyncNoteRow: FC<ItemListAsyncNoteRowProps> = observer(({ data }) => {
  const { store } = useAppStore();
  const note = store.notes.get(data.payload.noteId);
  const shouldAllowTrashed = data.payload.allowTrashed ?? false;

  if (!note || note.isDeleted || !note.canAccess) return null;

  if (note.isTrashed && !shouldAllowTrashed) return null;

  const itemRowData =
    typeof data.payload.itemRow === "function" ? data.payload.itemRow(note) : data.payload.itemRow;

  const { id, appearance, listState } = itemRowData.payload;
  const noSeparator =
    listState?.shouldHideSeparator({ itemId: id, appearance }) ??
    APPEARANCES_WITHOUT_SEPARATOR_SET.has(appearance);

  return <ItemListItemRow data={itemRowData} noSeparator={noSeparator} />;
});
